import { costFormatter } from '../../format';
import { getVariantByRecipes } from '../../products';
import { ApiResult } from '../../api';
import { PRODUCT_TYPES, STATE } from './constants';

export const showNoRecipeFound = (productTypes = {}) => {
  return Object.keys(productTypes).every(
    productType =>
      productTypes[productType].availableRecipes.fresh.length <= 0 &&
      productTypes[productType].availableRecipes.dry.length <= 0,
  );
};

export const getMealPrepTypeFromRecipes = (
  recipes = { fresh: [], dry: [] },
) => {
  if (!!recipes.fresh.length && !!recipes.dry.length) {
    return PRODUCT_TYPES.mixed;
  }

  if (!!recipes.fresh.length) {
    return PRODUCT_TYPES.fresh;
  }

  if (!!recipes.dry.length) {
    return PRODUCT_TYPES.dry;
  }

  // If there are no recipes, we continue with the default
  return '';
};

export const parsePath = path =>
  path.match(/(?<=\/onboarding\/)[\w-/?]+([^/])/g);

export const getPrices = (offer, variant) => ({
  discount: `${offer.formattedAmount} OFF`,
  periodPrice: costFormatter(variant.price_per_week),
  discountedPeriodPrice: costFormatter(variant.discounted_price_per_week),
});

// Create product look-alike from the line item & product.
// The lineItem model has many of the same properties but isn't
// the same shape as the product, so we take the lineItem pricing,
// because a starter box line item will have different price than
// its associated product, and the relevant info from the product
// model, to create this "cartProduct" object.
//
// Note that you'll only use this object if you're editing a pet
// with a product in the cart (hence the `null` fallback).
export const getCartProduct = (product, lineItemForPet) => {
  if (!lineItemForPet) {
    return null;
  }

  if (!product) return null;
  return {
    tray_count: product.variants[0].tray_count,
    variants: [
      {
        sku: lineItemForPet.sku,
        recipes: lineItemForPet.recipes,
        price_per_week: lineItemForPet.price_per_week,
        discounted_price_per_week: lineItemForPet.discounted_price_per_week,
      },
    ],
  };
};

export const submit = async (ctx, payload) => {
  const { mealPrepType } = ctx;
  const {
    productTypes,
    cartApi,
    reporter,
    cartProduct,
    petId,
    setShowModal,
    setLocalSelection,
  } = payload.props;
  const lineItemForPet = cartProduct?.variants[0];

  const variants = productTypes[mealPrepType].starterBoxes[0].variants;

  const variant = getVariantByRecipes(variants, ctx.recipes);

  if (variant.sku === lineItemForPet?.sku) {
    return ApiResult.success();
  }
  const result = await cartApi.addToCart({
    product_sku: variant.sku,
    subscription_sku: variant.subscription_sku,
    quantity: 1,
    pet_id: petId,
  });

  ApiResult.match(result, {
    success: () => setLocalSelection(null, { skipRender: true }),
    error: {
      client: error => {
        reporter.error(error.original);
        setShowModal(true);
      },
      server: () => setShowModal(true),
    },
  });

  return result;
};

export const getHighestDailyCalories = subscriptionProducts => {
  const { fresh, dry, mixed } = subscriptionProducts;
  let sortedProductsByCalories = [fresh[0], dry[0], mixed[0]].sort((a, b) => {
    return parseInt(b.kcalories_per_day) - parseInt(a.kcalories_per_day);
  });
  return sortedProductsByCalories[0].kcalories_per_day;
};

export const onCartSubmission = service => {
  if (service.machine.current !== STATE.submitCart) {
    return Promise.resolve(ApiResult.success());
  }
  return new Promise(resolve => {
    const checkSuccess = setInterval(() => {
      if (service.machine.current !== STATE.submitCart) {
        clearInterval(checkSuccess);
        resolve(service.context.submitCartResult);
      }
    }, 500);
  });
};
